import { Grid, Typography, WithStyles } from 'material-ui'
import { StyleRulesCallback } from 'material-ui/styles'
import withStyles from 'material-ui/styles/withStyles'
import * as React from 'react'
import { SFC } from 'react'
import { BlueGreenBar } from './BlueGreenBar'

interface Props {
    clientName: string
    clientTitle: string
    clientImg: string
    quote: string
    short?: boolean
}

const styles: StyleRulesCallback = theme => ({
    image: {
        [theme.breakpoints.up('sm')]: {
            textAlign: 'right'
        },
        [theme.breakpoints.down('sm')]: {
            textAlign: 'center'
        },
    },
})

const Component: SFC<WithStyles & Props> = ({clientImg, clientName, clientTitle, quote, short, classes}) => {
    return (
        <Grid container spacing={24}>
            <Grid item xs={12} sm={short ? 4 : 3} className={classes.image}>
                <img src={clientImg} alt={clientName} style={{margin: '20', width: 175}}/>
            </Grid>
            <Grid item xs={12} sm={short ? 8 : 9} style={{textAlign: 'left'}}>
                <div style={{margin: '10px 0px'}}>
                    <BlueGreenBar size={8} width={250}/>
                </div>
                <Typography type='display1' style={{lineHeight: '1.5em', maxWidth: short ? 550 : 650, fontWeight: 100}}>
                    {quote}
                </Typography>
                <div style={{margin: '15px 0px'}}>
                    <Typography
                        type='title'
                        color={'primary'}
                        style={{fontSize: '1em', fontWeight: 100}}
                    >
                        {clientName}
                    </Typography>
                    <Typography type='subheading' style={{color: '#aaa'}}>{clientTitle}</Typography>
                </div>
            </Grid>
        </Grid>
    )
}

export const ClientQuote = withStyles(styles)<Props>(Component)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/components/ClientQuote.tsx